// extracted by mini-css-extract-plugin
module.exports = {"form":"GiftCardAmount_form__II7pG","footer":"GiftCardAmount_footer__vG5Hf","error":"GiftCardAmount_error__wTrH4"};